import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  OutputEmitterRef,
  Signal,
  computed,
  input,
  output,
} from '@angular/core';

import { SelectComponent, SelectOption } from '@core/ui';
import { FacetBase, ListFacetBase, SingleSelectFacet } from '@mp/shared/facets/domain';

@Component({
  selector: 'mp-type-facet-value-selector',
  templateUrl: './type-facet-value-selector.component.html',
  styleUrl: './type-facet-value-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectComponent],
})
export class TypeFacetValueSelectorComponent {
  readonly typeFacet: InputSignal<SingleSelectFacet> = input.required<SingleSelectFacet>();

  readonly selectedTypeFacetBucket: InputSignal<SingleSelectFacet.Bucket | undefined> =
    input<SingleSelectFacet.Bucket>();

  readonly selectedTypeFacetBucketChange: OutputEmitterRef<SingleSelectFacet.Bucket> =
    output<SingleSelectFacet.Bucket>();

  protected readonly bucketSelectOptions: Signal<SelectOption<ListFacetBase.Bucket>[]> = computed(() =>
    this.getTypeFacetSelectOptions(this.typeFacet()),
  );

  onBucketSelected(selectedBucket: SingleSelectFacet.Bucket | undefined): void {
    if (!selectedBucket) {
      return;
    }

    this.selectedTypeFacetBucketChange.emit(selectedBucket);
  }

  compareByVal(a: FacetBase.BucketBase, b: FacetBase.BucketBase): boolean {
    return a.value === b.value;
  }

  private getTypeFacetSelectOptions(
    typeFacet: SingleSelectFacet | null | undefined,
  ): SelectOption<ListFacetBase.Bucket>[] {
    if (!typeFacet) {
      return [];
    }

    return typeFacet.buckets.map((bucket) => ({ label: bucket.label, value: bucket }));
  }
}
